import Vue from "vue";
import Vuex from "vuex";
import http from "../utils/http";
import { adminStore } from "../admin-module";
import { logisticStore } from "../logistic-module";
import { displayStore } from "../utils/displayStore";
import { dentalClinicStore } from "../dental-clinic-module/store";
import {authStore} from "src/lt/auth-module/authStore.js";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    user: {}, // usuario autentificado
    config: {},
    permissions: []
  },
  mutations: {
    setUser(state, user) {
      state.user = user;
      state.permissions = user.permissions;
    },
    setConfig(state, newConfig) {
      state.config = newConfig;
    }
  },
  actions: {
    login({ commit, dispatch }, userVals) {
      return new Promise((resolve, error) => {
        http.post("oauth/token", {
            ...userVals,
            grant_type: process.env.VUE_APP_GRANT_TYPE,
            client_id: process.env.VUE_APP_CLIENT_ID,
            client_secret: process.env.VUE_APP_CLIENT_SECRET,
            scope: process.env.VUE_APP_SCOPE
          })
          .then(
            async res => {
              localStorage.setItem("access_token", res.data.access_token);
              localStorage.setItem("refresh_token", res.data.refresh_token);
              await dispatch("getUser");
              resolve();
            },
            ({ response }) => {
              error(
                (response && response.data.message) ||
                  "Error al intentar autenticar"
              );
            }
          );
      });
    },

    getUser({ commit }) {
      return new Promise((rsv, err) => {
        http.get("api/user", {
          params: { menu_module: 'DEN' }
        }).then(
          (res) => {
            commit("setConfig", res.data.config);
            delete res.data.config;
            commit("setUser", res.data);
            rsv();
          },
          () => err()
        );
      });
    },

    authAfterLogged({ dispatch }) {
      return new Promise((rsv) => {
        Promise.all([dispatch("getUser")])
          .then(
            () => {
              rsv();
            },
            () => {
              dispatch("auth/logout");
            }
          )
          .then(() => {
            rsv();
          });
      });
    },

    beforeInstance({ dispatch }) {
      return dispatch("authAfterLogged");
    }
  },
  modules: {
    auth: authStore,
    admin: adminStore,
    logistic: logisticStore,
    display: displayStore,
    dental: dentalClinicStore
  }
});
